import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
    branchPost,
    handleInputChange,
    clearBranch,
    searchUsers,
    handleSelectUser,
} from '../../redux/actions/branch/branch.actions';
import ReactTooltip from 'react-tooltip';
import { SwalFormWarning } from '../../Services/_swal.service';
import BeforeUnloadComponent from 'react-beforeunload-component';
import { useHistory } from 'react-router-dom';
import { blockRoute } from '../../redux/actions/helper/helper.actions';

function BranchCreateGlobal({
    branch: { single_branch, main_page, main_url, user_options, selected_user },
    handleInputChange,
    branchPost,
    pageOrigin,
    clearBranch,
    block_route,
    blockRoute,
    searchUsers,
    handleSelectUser,
}) {
    const [selectedOption, setSelectedOption] = useState(null);
    let history = useHistory();

    useEffect(() => {
        clearBranch();
        blockRoute(false);
    }, []);

    useEffect(() => {
        window.addEventListener('beforeunload', function (e) {
            delete e['returnValue'];
            blockRoute(false);
        });

        if (block_route) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', onBackButtonEvent);
        }

        return () => {
            window.removeEventListener('popstate', onBackButtonEvent);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [block_route]);

    const onBackButtonEvent = (e) => {
        e.preventDefault();
        if (block_route) {
            SwalFormWarning(
                'Warning',
                'Do you want to leave without saving',
                () => goLastLocation(),
                () => blockAgain()
            );
        }
    };

    const goLastLocation = () => {
        history.goBack();
        blockRoute(false);
    };

    const blockAgain = () =>
        window.history.pushState(null, null, window.location.pathname);

    const hasUser = selectedOption !== null;
    return (
        <BeforeUnloadComponent
            blockRoute={block_route}
            ignoreChildrenLinks={true}
            modalComponentHandler={({
                handleModalLeave,
                handleModalCancel,
            }) => {
                SwalFormWarning(
                    'Warning',
                    'Do you want to leave without saving',
                    () => handleModalLeave(),
                    () => handleModalCancel()
                );
            }}
        >
            <form onSubmit={(e) => branchPost(e, pageOrigin)}>
                <ReactTooltip effect="solid" event="click" />
                <section className="row">
                    <div className="col-12">
                        <div className="row">
                            {/* ── User search bar ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    Search User:{' '}
                                    <span className="text-danger">*</span>
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <Select
                                            value={selectedOption}
                                            options={user_options}
                                            onInputChange={(inputValue) => {
                                                searchUsers(inputValue);
                                            }}
                                            onChange={(option) => {
                                                setSelectedOption(option);
                                                handleSelectUser(option);
                                                if (option) {
                                                    blockRoute(true);
                                                }
                                            }}
                                            placeholder="Type to search user..."
                                            isClearable
                                            isSearchable
                                            noOptionsMessage={() =>
                                                'No users found'
                                            }
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="Search a user to auto-fill branch details"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Name ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    Name: <span className="text-danger">*</span>
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="name"
                                            value={single_branch.name || ''}
                                            className="form-control f-regular"
                                            placeholder="Name"
                                            disabled={!hasUser}
                                            required
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Business Name ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    Business Name:{' '}
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="business_name"
                                            value={
                                                single_branch.business_name ||
                                                ''
                                            }
                                            className="form-control f-regular"
                                            placeholder="Business Name"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Street 1 ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    Street 1:{' '}
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <textarea
                                            onChange={handleInputChange}
                                            name="street1"
                                            rows="3"
                                            value={single_branch.street1 || ''}
                                            className="form-control f-regular"
                                            placeholder="Street 1"
                                            disabled={!hasUser}
                                            style={{
                                                height: '80px',
                                                resize: 'none',
                                            }}
                                        ></textarea>
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Street 2 ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    Street 2:{' '}
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <textarea
                                            onChange={handleInputChange}
                                            name="street2"
                                            rows="3"
                                            value={single_branch.street2 || ''}
                                            className="form-control f-regular"
                                            placeholder="Street 2"
                                            disabled={!hasUser}
                                            style={{
                                                height: '80px',
                                                resize: 'none',
                                            }}
                                        ></textarea>
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── City ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">City: </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="city"
                                            value={single_branch.city || ''}
                                            className="form-control f-regular"
                                            placeholder="City"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── State/Region ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    State/Region:{' '}
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="state"
                                            value={single_branch.state || ''}
                                            className="form-control f-regular"
                                            placeholder="State/Region"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Landline ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    Landline:{' '}
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="landline"
                                            value={single_branch.landline || ''}
                                            className="form-control f-regular"
                                            placeholder="Landline"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Mobile ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    Mobile:{' '}
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="mobile"
                                            value={single_branch.mobile || ''}
                                            className="form-control f-regular"
                                            placeholder="Mobile"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Fax ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">Fax: </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="fax"
                                            value={single_branch.fax || ''}
                                            className="form-control f-regular"
                                            placeholder="Fax"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── TIN ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">TIN: </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="tin"
                                            value={single_branch.tin || ''}
                                            className="form-control f-regular"
                                            placeholder="TIN"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Email ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">Email: </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="email"
                                            name="email"
                                            value={single_branch.email || ''}
                                            className="form-control f-regular"
                                            placeholder="Email"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Contact Person ── */}
                            <div className="col-12 col-md-6">
                                <label className="label-control">
                                    Contact Person:{' '}
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={handleInputChange}
                                            type="text"
                                            name="contact_person"
                                            value={
                                                single_branch.contact_person ||
                                                ''
                                            }
                                            className="form-control f-regular"
                                            placeholder="Contact Person"
                                            disabled={!hasUser}
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Save button ── */}
                            <div className="col-6 offset-6">
                                <div className="form-group row mt-3">
                                    <div className="col-md-12 col-8 text-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-save"
                                            disabled={!hasUser}
                                        >
                                            Save Branch
                                        </button>
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </form>
        </BeforeUnloadComponent>
    );
}

const mapStateToProps = (state) => ({
    branch: state.branch,
    block_route: state.helper.block_route,
});

export default connect(mapStateToProps, {
    handleInputChange,
    branchPost,
    clearBranch,
    blockRoute,
    searchUsers,
    handleSelectUser,
})(BranchCreateGlobal);
